<body>
  <app-nav-menu></app-nav-menu>
  <router-outlet></router-outlet>
  <footer id="footer" class="footer-fixed">
    <div class="container">
      <div class="copyright">
        &copy; Copyright
        <span> BS Code All Rights Reserved - 2025 ({{ version }})</span>
      </div>
    </div>
  </footer>
</body>
<p-toast></p-toast>
